<div class="container-fluid">
    <div class="header-container">
        <div class="page-header"><span class="fa fa-file-text-o"></span>Client claim form</div>
    </div>

    <div class="content" style="padding-bottom: 30px;">

        <div class="row" style="padding-bottom: 30px;">
            <div class="col-xs-12 col-sm-12 col-md-12">
                <div class="well well-sm">
                    <div class="row">
                        <div class="col-sm-6 col-md-1">
                        </div>
                        <div class="col-sm-6 col-md-5">
                            <h3 style="color: #0079c1; padding-top:6px">
                                {{claimObject.InsuredName}}
                            </h3>
                            <small style="color: gray;font-size: 15px;">
                                <cite title="email"><i class="fa fa-envelope"></i> {{claimObject.InsuredeMail}}</cite>
                            </small>
                            <br/>
                            <small style="color: gray;font-size: 15px;">
                                <cite title="phone"><i class="fa fa-phone"></i> {{claimObject.InsuredPhone}}</cite>
                            </small>
                        </div>
                        <div class="col-sm-6 col-md-6">

                        </div>
                    </div>
                </div>
            </div>
        </div>


        <!--MENU-->
        <p-tabMenu [model]="tabMenuItems" [activeItem]="selectedTabMenuItem">
            <ng-template pTemplate="item" let-item let-i="index" style="padding:0px;">
                <div class="menu-container-filter" (click)="showPage(item.ID)">
                    <div class="menu-card-container-filter">
                        <div class="menu-card-filter">
                            <div class="menu-footer-filter">
                                <div>{{item.title}}</div>
                                <div class="footer-description-filter">{{item.description}}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-template>
        </p-tabMenu>


        <!--CLAIMS-->
        <div class="content" *ngIf="showClaims">
            <div>
                <div>
                    <div class="row">
                        <div class="col-md-6">
                            <div class="row margin-top-8">
                                <h5 style="margin-left: 15px;">Insured Details:</h5>
                            </div>
                            <div class="row margin-top-8">
                                <div class="col-md-4 label">Name:</div>
                                <div class="col-md-8">
                                    <div class="p-inputgroup">
                                        <input type="text" pInputText placeholder="Insured's name" name="insuredName"
                                               [(ngModel)]="claimObject.InsuredName"/>
                                    </div>
                                </div>
                            </div>
                            <div class="row margin-top-8">
                                <div class="col-md-4 label">eMail:</div>
                                <div class="col-md-8">
                                    <div class="p-inputgroup">
                                        <input type="email" pInputText placeholder="Insured's eMail" name="insuredeMail"
                                               [(ngModel)]="claimObject.InsuredeMail"/>
                                    </div>
                                </div>
                            </div>
                            <div class="row margin-top-8">
                                <div class="col-md-4 label">Phone:</div>
                                <div class="col-md-8">
                                    <div class="p-inputgroup">
                                        <input type="text" pInputText placeholder="Insured's phone number"
                                               name="insuredPhone"
                                               [(ngModel)]="claimObject.InsuredPhone"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div>
                <div>
                    <div class="row">


                        <div class="col-md-6">

                            <div class="row margin-top-8">
                                <h5 style="margin-left: 15px;">Item Details:</h5>
                            </div>

                            <div class="row margin-top-8">
                                <div class="col-md-4 label">Bikes:</div>
                                <div class="col-md-8">
                                    <div class="p-inputgroup">
                                        <p-chips [(ngModel)]="bikes" class="full-width"
                                                 placeholder="Enter bike name and press enter. Multiple bikes can be added."
                                                 (onAdd)="addBike($event)" (onRemove)="removeBike($event)"></p-chips>
                                    </div>
                                </div>
                            </div>
                            <div class="row margin-top-8">
                                <div class="col-md-4 label">Select your bike below to view details</div>
                                <div class="col-md-8">
                                    <div class="p-inputgroup">
                                        <div class="p-g" style="margin-bottom:10px">
                                            <div class="row">
                                                <div class="col-md-12">
                                                    <div class="col-md-12" *ngFor="let col of bikeSelectList"
                                                         style="padding:5px;">
                                                        <div>
                                                            <p-radioButton name="bikesGroup" value="{{col.label}}"
                                                                           label="{{col.label}}"
                                                                           [(ngModel)]="bikeSelected" inputId="opt1"
                                                                           (onClick)="showComponents()"></p-radioButton>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row margin-top-8">
                                <div class="col-md-4 label">Components</div>
                                <div class="col-md-8">
                                    <div class="p-inputgroup">
                                        <p-chips [(ngModel)]="components" class="full-width"
                                                 placeholder="Enter components for the above selected bike."
                                                 (onAdd)="addComponentToBike($event)"
                                                 (onRemove)="removeComponentToBike($event)"></p-chips>
                                    </div>
                                </div>
                            </div>

                            <div class="row margin-top-8">
                                <div class="col-md-4 label">Sum insured:</div>
                                <div class="col-md-8">
                                    <div class="p-inputgroup">
                                        <input type="text" pInputText placeholder="Sum insured" name="sumInsured"
                                               [(ngModel)]="sumInsured"
                                               readonly/>
                                        <!--<p-inputNumber [(ngModel)]="sumInsured" mode="decimal" locale="en-US" [minFractionDigits]="2"></p-inputNumber>-->
                                    </div>
                                </div>
                            </div>

                            <div class="row margin-top-8">
                                <div class="col-md-4 label">Excess:</div>
                                <div class="col-md-8">
                                    <div class="p-inputgroup">
                                        <input type="text" pInputText placeholder="Excess" name="excess"
                                               [(ngModel)]="excess" readonly/>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div class="col-md-6">
                            <div class="row margin-top-8">
                                <h5 style="margin-left: 15px;">Incident Details:</h5>
                            </div>
                            <div class="row margin-top-8">
                                <div class="col-md-4 label">Type of Incident:</div>
                                <div class="col-md-8">
                                    <div class="p-inputgroup">
                                        <p-dropdown [options]="incidentTypes"
                                                    [(ngModel)]="selectedIncidentType"></p-dropdown>
                                    </div>
                                </div>
                            </div>

                            <!--<div class="row margin-top-8">
                              <div class="col-md-4 label">Incident Date:</div>
                              <div class="col-md-8">
                                <div class="p-inputgroup">
                                  <p-calendar [(ngModel)]="claimObject.IncidentDate" placeholder="Incident date"></p-calendar>
                                </div>
                              </div>
                            </div>-->

                            <div class="row margin-top-8">
                                <div class="col-md-4 label">Incident Location:</div>
                                <div class="col-md-8">
                                    <div class="p-inputgroup">
                                        <input type="text" pInputText [(ngModel)]="claimObject.IncidentLocation"
                                               placeholder="Address where incident occured"/>
                                    </div>
                                </div>
                            </div>
                            <div class="row margin-top-8">
                                <div class="col-md-4 label">Incident Date:</div>
                                <div class="col-md-8">
                                    <div class="p-inputgroup">
                                        <p-calendar [(ngModel)]="claimObject.IncidentDate"
                                                    placeholder="Incident date"></p-calendar>
                                    </div>
                                </div>
                            </div>
                            <div class="row margin-top-8">
                                <div class="col-md-4 label">Incident Description:</div>
                                <div class="col-md-8">
                                    <div class="p-inputgroup">
                    <textarea pInputTextarea [rows]="5" placeholder="Description of the incident that led to the claim"
                              name="incidentDetails" [(ngModel)]="claimObject.IncidentDetails"></textarea>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!--ATTACHMENTS-->
        <div class="content" *ngIf="showAttachments">
            <div class="row">
                <div class="col-md-4">

                    <!--          todo (dcorbett) p-galleria changes for angular-->
                    <p-galleria [value]="images"
                    ></p-galleria>
                </div>
                <div class="col-md-4">
                    <div class="row margin-top-8">
                        <h5 style="margin-left: 15px;">Documents:</h5>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="row margin-top-8">
                        <h5 style="margin-left: 15px;">Attachments:</h5>
                    </div>
                    <!--          todo (dcorbett) wrong multple-->
                    <p-fileUpload [customUpload]="true" name="demo[]" (onUpload)="onUpload($event)"
                                  (uploadHandler)="onUpload($event)" (onRemove)="onRemove($event)"
                                  [multiple]="true" accept="image/*,application/*,text/*" [maxFileSize]="4000000000"
                                  [auto]="true" [showUploadButton]="false" [showCancelButton]="false">
                        <ng-template pTemplate="content">
                        </ng-template>
                    </p-fileUpload>

                </div>
            </div>

        </div>


    </div>

    <div class="content" style="padding-bottom: 30px;margin-bottom: 50px;margin-top: 30px;">
        <div class="row">
            <div class="col-md-2">
                <button pButton type="button" class="p-button-raised full-width" label="Save"
                        (click)="minimizeAndSaveClaim()"
                        [disabled]="saving"></button>
            </div>
        </div>
    </div>

</div>
